const mock = {
    "results": {
      "score": 3,
      "maxScore": 10
    },
    "submissionDate": null,
    "passed": null,
    "sealed": false,
    "questions": [
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "c4184404-fc0f-4338-90d9-fdc4089f786d",
        "type": "SingleChoice",
        "content": "Warm and sincere closing, along with appreciation, should be demonstrated by every front desk team member.",
        "options": [
          {
            "id": 0,
            "value": "True"
          },
          {
            "id": 1,
            "value": "False"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "4d879208-d377-4364-a415-4fdfd8b43fe5",
        "type": "SingleChoice",
        "content": "Does front desk agent need to inquire if the guest has a Marriott Bonvoy Member number during check out as well?",
        "options": [
          {
            "id": 0,
            "value": "Yes"
          },
          {
            "id": 1,
            "value": "No"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "d9afe4c3-02ca-4c94-ada8-f72fda621fed",
        "type": "SingleChoice",
        "content": "Front desk agent should offer transportation to the guest during the check out.",
        "options": [
          {
            "id": 0,
            "value": "True"
          },
          {
            "id": 1,
            "value": "False"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "37f36c0c-0f46-472f-8b99-c066700cead8",
        "type": "MultiChoice",
        "content": "What should frond desk agent do when need to decline the guest’s request?",
        "options": [
          {
            "id": 0,
            "value": "Offer alternative option"
          },
          {
            "id": 1,
            "value": "Tell him/her to ask anyone else"
          },
          {
            "id": 2,
            "value": "Say ‘’No’’ when the request cannot be completed"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "3af84708-9f5a-4a51-8b95-69d5c67a7b5b",
        "type": "MultiChoice",
        "content": "Which answer is not correct when owning and resolving the guest request?",
        "options": [
          {
            "id": 0,
            "value": "Listen actively"
          },
          {
            "id": 1,
            "value": "Express empathy"
          },
          {
            "id": 2,
            "value": "Resolve/solve the problem within 30 minutes"
          },
          {
            "id": 3,
            "value": "Apologize and assume ownership"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "6d9bb17e-26c6-4f08-b00e-526b2c6d55e4",
        "type": "MultiChoice",
        "content": "Why is offering further assistance to the guest important?",
        "options": [
          {
            "id": 0,
            "value": "It helps the staff save time"
          },
          {
            "id": 1,
            "value": "It is a requirement, but it doesn't impact the guest's experience"
          },
          {
            "id": 2,
            "value": "It's unnecessary as guests usually decline additional help"
          },
          {
            "id": 3,
            "value": "Tailoring service to individual guest preferences and needs"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "de12f198-4310-4c97-8e0a-6ca8702e3349",
        "type": "SingleChoice",
        "content": "How can an attendant personalize service without breaching guest privacy?",
        "options": [
          {
            "id": 0,
            "value": "Avoid using guest names"
          },
          {
            "id": 1,
            "value": "Share personal anecdotes about the attendant"
          },
          {
            "id": 2,
            "value": "Use learned information discreetly"
          },
          {
            "id": 3,
            "value": "Request personal details from the guest"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "a7ef20d6-23df-40df-b0d7-a0fcd6f01ccb",
        "type": "MultiChoice",
        "content": "Which one is the wrong answer for the check-in procedure?",
        "options": [
          {
            "id": 0,
            "value": "Provide room number either verbally or non-verbally"
          },
          {
            "id": 1,
            "value": "To offer assistance for the internet during check in"
          },
          {
            "id": 2,
            "value": "Ask the number of room keys required"
          },
          {
            "id": 3,
            "value": "Use appropriate verbiage with genuine delivery"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "0c184423-732f-4db3-8c8f-965f31f6cf7f",
        "type": "SingleChoice",
        "content": "If standing in a queue, an attempt to acknowledge the guest should be made in a timely manner.",
        "options": [
          {
            "id": 0,
            "value": "True"
          },
          {
            "id": 1,
            "value": "False"
          }
        ]
      },
      {
        "testId": "27f6d13e-9c00-474c-9c85-ceba71f792f2",
        "id": "4039c6da-2c29-4675-b687-07acf607b1c7",
        "type": "SingleChoice",
        "content": "It is not obligatory to recognize all Marriott Bonvoy members during their check in.",
        "options": [
          {
            "id": 0,
            "value": "True"
          },
          {
            "id": 1,
            "value": "False"
          }
        ]
      }
    ],
    "answers": null,
    "startsAt": "2024-09-28T21:00:23.3181215+00:00",
    "endsAt": "2024-09-30T21:00:23.3181223+00:00"
  };

export default mock;